import { getCookie } from '@utiljs/cookie';

import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';
import { isInApp } from '@utils/getEnv';
import { getPoiEnabledConnectedPrinters } from '@utils/print/printer';
import request from '@utils/axiosWrapper';

import getAppInfo from './getAppInfo';

const COMMON_INFO_REPORT_TIME_STORAGE_KEY = 'commonInfoReportTime';
const COMMON_INFO_REPORT_POI_STORAGE_KEY = 'commonInfoReportPoi';

const { appCode, platform, appFullVersion, systemRelease } = getAppInfo();

const SHARED_DATA = {
    logLevel: 'info',
    time: new Date().getTime(),
    acctId: Ids.getAcctId(),
    wmPoiId: Ids.getWmPoiId(),
    appCode,
    appVer: appFullVersion,
    sysVer: systemRelease,
};

const SHARED_DATA_CUSTOM = {
    isInApp,
    ua: navigator.userAgent,
    httpType: window.location.protocol.replace(/:$/g, ''),
};

const reportCommonInfo = () => {
    const now = new Date().getTime();
    const today = Math.floor(now / 86400000);

    const lastReportDay = Number(getStorage(COMMON_INFO_REPORT_TIME_STORAGE_KEY));

    if (lastReportDay < today) {
        // 新的一天，从清空上报门店ID列表开始
        setStorage(COMMON_INFO_REPORT_POI_STORAGE_KEY, '');
    }

    const todayReportedPoiList = (getStorage(COMMON_INFO_REPORT_POI_STORAGE_KEY) || '').split(',');
    if (todayReportedPoiList.includes(Ids.getWmPoiId())) {
        return;
    }

    const reportData: any = {
        event: 'CommonInfo',
        ...SHARED_DATA,
    };
    const reportDataCustom: any = {
        ...SHARED_DATA_CUSTOM,
        printers: [],
    };

    reportData.data = reportDataCustom;

    // 壳子相关
    if (isInApp) {
        reportDataCustom.systemInfo = {
            platform,
        };

        reportDataCustom.printers = getPoiEnabledConnectedPrinters(Ids.getWmPoiId());
    }

    // 屏幕信息
    const screen = window.screen;
    if (screen) {
        reportDataCustom.screen = {
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
        };
    }

    // 用户 ID 信息
    const catUnionId = getCookie('unionid') || getCookie('dpid') || getCookie('_lxsdk_cuid');
    const idInfo: any = {
        acctId: Ids.getAcctId(),
        wmPoiId: Ids.getWmPoiId(),
        deviceUuid: Ids.getDeviceId(),
        catUnionId,
    };
    reportDataCustom.idInfo = idInfo;

    let promise: Promise<any>;
    if (window.wmClientApi && window.wmClientApi.getClientInfo) {
        promise = window.wmClientApi.getClientInfo().then(appInfo => {
            idInfo.clientUuid = appInfo.deviceUuid;
        });
    } else {
        promise = Promise.resolve();
    }

    promise.then(() => {
        request
            .postAsFormSubmit('/v2/pc/report/log', {
                data: JSON.stringify([reportData]),
            })
            .then(() => {
                setStorage(COMMON_INFO_REPORT_TIME_STORAGE_KEY, `${today}`);
                setStorage(
                    COMMON_INFO_REPORT_POI_STORAGE_KEY,
                    [...todayReportedPoiList, Ids.getWmPoiId()].join(','),
                );
            });
    });
};

const CLIENT_INFO_REPORT_TIME_STORAGE_KEY = 'waimai_e_clientInfoReportTime';
const reportClientInfo = () => {
    const now = new Date().getTime();
    const today = Math.floor(now / 86400000);
    const lastReportDay = Number(getStorage(CLIENT_INFO_REPORT_TIME_STORAGE_KEY));

    if (lastReportDay === today) {
        // 同一个设备，一天只上报1次
        return;
    }
    const reportData: any = {
        event: 'ClientInfo',
        ...SHARED_DATA,
    };
    const reportDataCustom: any = {
        ...SHARED_DATA_CUSTOM,
    };
    reportData.data = reportDataCustom;

    if (isInApp) {
        // 系统版本
        reportDataCustom.systemInfo = {
            platform,
        };
    }

    // 屏幕信息
    const screen = window.screen;
    if (screen) {
        reportDataCustom.screen = {
            width: screen.width,
            height: screen.height,
            availWidth: screen.availWidth,
            availHeight: screen.availHeight,
        };
    }

    request
        .postAsFormSubmit('/v2/pc/report/log', {
            data: JSON.stringify([reportData]),
        })
        .then(() => {
            setStorage(CLIENT_INFO_REPORT_TIME_STORAGE_KEY, `${today}`);
        });
};

const reportAllFeInfo = () => {
    reportCommonInfo();
    reportClientInfo();
};

// eslint-disable-next-line import/prefer-default-export
export { reportAllFeInfo };
